"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _reactFroalaWysiwyg = _interopRequireDefault(require("react-froala-wysiwyg"));

var _reactRedux = require("react-redux");

var _reselect = require("reselect");

var _uuid = _interopRequireDefault(require("uuid"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

class FroalaCustomUpload extends _react.Component {
  constructor(props) {
    var _a;

    super(props);

    this.onModelChange = model => {
      const {
        onChange,
        disabled
      } = this.props;

      if (!disabled) {
        onChange(model);
      }
    };

    const {
      disabled,
      oidc
    } = props;
    this.froalaRef = /*#__PURE__*/_react.default.createRef();
    this.key = (0, _uuid.default)();
    this.config = {
      autoSave: true,
      saveInterval: 1000,
      immediateReactModelUpdate: true,
      charCounterCount: true,
      fontFamilySelection: true,
      fontSizeSelection: true,
      iconsTemplate: 'font_awesome_5r',
      imageMaxSize: 16 * 1024 * 1024,
      imageUploadParam: 'file',
      imageUploadMethod: 'POST',
      imageUploadURL: '/api/a/cms/uploads/image',
      requestHeaders: {
        Authorization: `Bearer ${(_a = oidc.user) === null || _a === void 0 ? void 0 : _a.access_token}`
      },
      pluginsEnabled: ['align', 'charCounter', 'codeBeautifier', 'codeView', 'colors', 'draggable', 'emoticons', 'entities', 'fontFamily', 'fontSize', 'fullscreen', 'help', 'image', 'inlineClass', 'inlineStyle', 'link', 'lists', 'paragraphFormat', 'paragraphStyle', 'print', 'quote', 'save', 'specialCharacters', 'spellChecker', 'table', 'url', 'video', 'wordPaste'],
      events: {
        async initialized() {
          if (disabled) {
            await new Promise(resolve => setTimeout(resolve, 1));
            this.edit.off();
          }
        }

      },
      linkAutoPrefix: ''
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.disabled && !this.props.disabled) {
      const editor = this.froalaRef.current;

      if (editor && editor.getEditor() && editor.getEditor().edit) {
        editor.getEditor().edit.on();
      }
    } else if (!prevProps.disabled && this.props.disabled) {
      const editor = this.froalaRef.current;

      if (editor && editor.getEditor() && editor.getEditor().edit) {
        editor.getEditor().edit.off();
      }
    }
  }

  render() {
    const {
      model
    } = this.props;
    return /*#__PURE__*/_react.default.createElement(_reactFroalaWysiwyg.default, {
      ref: this.froalaRef,
      key: this.key,
      tag: "textarea",
      config: this.config,
      model: model,
      onModelChange: this.onModelChange
    });
  }

}

const mapStateToProps = (0, _reselect.createStructuredSelector)({
  oidc: selectors.selectOidc
});

var _default = (0, _reactRedux.connect)(mapStateToProps, null)(FroalaCustomUpload);

exports.default = _default;